import { Component } from '@angular/core';
import { FlowManagerService } from '../../shared/services/flowmanager.service';

@Component({
  selector: 'md-manual-docs',
  template: require('./manualDocs.component.html')
})

export class ManualDocsComponent {
  constructor(flowManager: FlowManagerService) {
    this.flowManager = flowManager;
    this.fundReqURL = `${this.flowManager.config.investDocsRoot}account-transfer`;
  }

  ngOnInit() {
    this.isAuthed = this.flowManager.isAuthed;
  }
}
